import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CommonObjectState {
  isModalState: boolean;
}

const commonObjectSlice = createSlice({
  name: "commonObjectData",
  initialState: { isModalState: false } as CommonObjectState,
  reducers: {
    setModalState: (state: CommonObjectState, action: PayloadAction<boolean>) => {
      state.isModalState = action.payload;
    },
  },
});

/** Maps fileVersionId → node offset ID (a number) */
type FileversionIdAndNodeOffsetIdMap = Record<string, number>;

const fileversionIdAndNodeOffsetIdMapSlice = createSlice({
  name: "fileversionIdAndNodeOffsetIdMap",
  initialState: {} as FileversionIdAndNodeOffsetIdMap,
  reducers: {
    setFileversionIdAndNodeOffsetIdMap: (
      _state: FileversionIdAndNodeOffsetIdMap,
      action: PayloadAction<FileversionIdAndNodeOffsetIdMap>,
    ) => action.payload,
  },
});

export const { setModalState } = commonObjectSlice.actions;
export const { setFileversionIdAndNodeOffsetIdMap } = fileversionIdAndNodeOffsetIdMapSlice.actions;

export const commonObjectData = commonObjectSlice.reducer;
export const fileversionIdAndNodeOffsetIdMap = fileversionIdAndNodeOffsetIdMapSlice.reducer;

export default commonObjectSlice.reducer;
